import { useSearchParams } from 'react-router-dom'
import { CalendarFilterParam } from '../enums/filter-params'
import dayjs, { Dayjs } from 'dayjs'
import { useMemo } from 'react'

export type UseDateReturn = {
  date: Dayjs,
  setDate: (date: Dayjs | ((prev: Dayjs) => Dayjs)) => void,
}

export const useDate = (): UseDateReturn => {
  const [searchParams, setSearchParams] = useSearchParams()

  const date = useMemo(() => {
    const dateParam = searchParams.get(CalendarFilterParam.DATE)
    if (dateParam && dayjs(dateParam).isValid()) {
      return dayjs.utc(dateParam)
    }
    return dayjs.utc()
  }, [searchParams])

  const setDate = (newDate: Dayjs | ((prev: Dayjs) => Dayjs)) => {
    const resolvedDate = typeof newDate === 'function' ? newDate(date) : newDate

    setSearchParams(prev => {
      if (resolvedDate.isSame(dayjs())) {
        prev.delete(CalendarFilterParam.DATE)
      } else {
        prev.set(CalendarFilterParam.DATE, resolvedDate.format('YYYY-MM-DD'))
      }

      return prev
    })
  }

  return { date, setDate }
}
